module.exports = __webpack_public_path__ + "static/img/cert7.84ff4d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutpic/cert7.png
// module id = iIQA
// module chunks = 51